import * as d3 from 'd3'
import * as dc from 'dc'
import { createEffectiveSpotMap } from '../calculations/convertNotionalToBRL.js'
import { calculateTotalVolumeBRL } from '../calculations/calculateTotalVolumeBRL.js'
import { calculateNegotiatedVolumeBRL, countNegotiated, calculateNegotiatedTicketBRL } from '../calculations/calculateNegotiatedVolumeBRL.js'
import { calculateConvertedVolumeBRL, countConverted, calculateConvertedTicketBRL } from '../calculations/calculateConvertedVolumeBRL.js'
import { calculateConversionRate } from '../calculations/calculateConversionRate.js'
import { calculateAverageSpreadPips } from '../calculations/calculateAverageSpreadPips.js'
import { calculateRevenueBRL } from '../calculations/calculateRevenueBRL.js'
import { formatResponsiveAmount } from './formatKpiAmount.js'

export function createTotalVolumeKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateTotalVolumeBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

// DEAL + NOTH.DONE
export function createNegotiatedVolumeKpi({ el, ndx, chartGroup, width }) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateNegotiatedVolumeBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

// DEAL
export function createConvertedVolumeKpi({ el, ndx, chartGroup, width }) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateConvertedVolumeBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

export function createConversionRateKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateConversionRate(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(d3.format('.2f'))
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

export function createAverageSpreadKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const group = {
    value: () => calculateAverageSpreadPips(ndx.allFiltered()),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(d3.format(',.2f'))
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

export function createRevenueKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateRevenueBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 4)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

// Contagem: inteiro puro, sem o formato responsivo dos valores em BRL - "1,2Mi"
// nao faz sentido para numero de RFQs.
const formatCount = d3.format(',d')

function createCountKpi({ el, ndx, chartGroup, width, count }) {
  const chart = new dc.NumberDisplay(el, chartGroup)
  chart
    .group({ value: () => count(ndx.allFiltered()) })
    .width(width / 2)
    .formatNumber(formatCount)
    .valueAccessor((value) => value)
  chart.render()
  return chart
}

function createTicketKpi({ el, ndx, chartGroup, width, ticket }) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())
  const chart = new dc.NumberDisplay(el, chartGroup)
  chart
    .group({ value: () => ticket(ndx.allFiltered(), effectiveSpotByRow) })
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)
  chart.render()
  return chart
}

// DEAL + NOTH.DONE
export function createNegotiatedTicketKpi(opts) {
  return createTicketKpi({ ...opts, ticket: calculateNegotiatedTicketBRL })
}

// DEAL
export function createConvertedTicketKpi(opts) {
  return createTicketKpi({ ...opts, ticket: calculateConvertedTicketBRL })
}

// DEAL + NOTH.DONE
export function createNegotiatedCountKpi(opts) {
  return createCountKpi({ ...opts, count: countNegotiated })
}

// DEAL
export function createConvertedCountKpi(opts) {
  return createCountKpi({ ...opts, count: countConverted })
}
